import React, { forwardRef } from 'react';
import { cx } from '../utils';
import './ProgressBar.css';

const clamp = (value) => {
  const number = Number(value);
  if (Number.isNaN(number)) return 0;
  return Math.min(100, Math.max(0, number));
};

// value: 0–100 (chegaradan tashqari qiymatlar qisqartiriladi).
// size: sm | md; tone: brand | success | info
// showValue — o'ng tomonda foiz matni.
const ProgressBar = forwardRef(function ProgressBar(
  { value = 0, size = 'sm', tone = 'brand', showValue = false, label, className, ...rest },
  ref
) {
  const percent = clamp(value);

  return (
    <div {...rest} ref={ref} className={cx('ui-progress', `ui-progress--${size}`, `ui-progress--${tone}`, className)}>
      <div
        className="ui-progress__track"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={percent}
        aria-label={label}
      >
        <div className="ui-progress__fill" style={{ width: `${percent}%` }} />
      </div>
      {showValue && <span className="ui-progress__value">{percent}%</span>}
    </div>
  );
});

export default ProgressBar;
